// components/PostEditor.tsx
import { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import FirebaseUploadAdapter from "../service/firebase/FirebaseUploadAdapter";

interface Props {
  htmlContent: string | null;
  onChange: (value: string) => void // 👈 add onChange prop
}

const PostEditor: React.FC<Props> = ({ htmlContent, onChange }) => {
  const [content, setContent] = useState(htmlContent || "");

    // if initialValue changes (e.g. after loading from Firestore), update editor
  useEffect(() => {
    setContent(htmlContent ?? "");
  }, [htmlContent]);

  function FirebaseUploadAdapterPlugin(editor: any) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
      return new FirebaseUploadAdapter(loader);
    };
  }

  return (
    <div>
    <CKEditor
        editor={ClassicEditor as any}
        data={content}
        config={{
          extraPlugins: [FirebaseUploadAdapterPlugin], // 👈 add plugin
        }}
        onChange={(_, editor) => {
          const data = editor.getData();
          setContent(data);
          onChange(data);  // pass content back to parent
        }}
    />
      {/* <button onClick={() => onSubmit(content)}>Save Post</button> */}
    </div>
  );
};

export default PostEditor;
